import React, { useEffect, useRef, useState } from "react";
import "./Brandinfo1.scss";
import Parallax from "parallax-js";
import { useHistory, useLocation } from "react-router";
import Slider from "react-slick";
import Mainlogos from "../Main/MainBanner/MainLogos";
import Logo from "../button/Logo";
import Backbutton from "../button/Backbutton";

const Brandinfo1 = () => {
  const [isOpen, setIsOpen] = useState(null);
  const [position, setPosition] = useState({ top: null, left: null });
  const [initialSlide, setInitialSlide] = useState(0);
  let sliders = useRef(null);
  const { pathname } = useLocation();
  let history = useHistory();
  useEffect(() => {
    setTimeout(function () {
      const pic_container = document.getElementsByClassName("photos");
      for (let i = 0; i < pic_container.length; i++) {
        let parallaxInstance = new Parallax(pic_container[i], {
          relativeInput: true,
        });
        parallaxInstance.friction(0.2, 0.2);
      }
    }, 1000);
  }, [isOpen]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleToggle = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const settings = {
    // className: "center",
    className: "main-slider",
    // centerMode: true,
    infinite: true,
    initialSlide: initialSlide,
    // centerPadding: "20px",
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    swipeToSlide: true,
  };

  const next = () => {
    sliders.slickNext();
  };
  const previous = () => {
    sliders.slickPrev();
  };
  const handleMouseMove = (e) => {
    // e.preventDefault();
    console.log("moving : ", e.pageX, e.pageY);
    setPosition({ top: e.pageY - 50, left: e.pageX - 50 });
  };

  return (
    <div>
      {isOpen ? (
        <>
          <div
            className="cursor_overlay"
            onMouseMove={(e) => {
              e.preventDefault();
              handleMouseMove(e);
            }}
          >
            <div
              className="left-side sides"
              onClick={() => {
                previous();
              }}
            >
              <img
                className="spot-one"
                style={{ top: position.top, left: position.left }}
                src="Images/Arrows/Left.svg"
              />
            </div>
            <div
              className="center-side sides"
              onClick={(e) => {
                console.log("closing");
                handleToggle(e);
              }}
            >
              <img
                className="spot-two"
                style={{ top: position.top, left: position.left }}
                src="Images/Arrows/Close.svg"
              />
            </div>
            <div
              className="right-side sides"
              onClick={() => {
                next();
              }}
            >
              <img
                className="spot-three"
                style={{ top: position.top, left: position.left }}
                src="Images/Arrows/Right.svg"
              />
            </div>
          </div>
          <Slider {...settings} ref={(c) => (sliders = c)}>
            <div key={1}>
              <img
                onClick={(e) => {
                  setInitialSlide(0);
                  handleToggle(e);
                }}
                src="Images/BrandInfo1/1.jpg"
                width="100% "
              ></img>
            </div>
            <div key={2}>
              <video
                autoPlay
                muted
                onClick={(e) => {
                  setInitialSlide(1);
                  handleToggle(e);
                }}
              >
                <source
                  type="video/mp4"
                  src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                />
              </video>
              {/* <img
          data-depth="0.1"
          src="Images/BrandInfo1/2.jpg"
          width="100% "
        ></img> */}
            </div>
            <div key={3}>
              <img
                onClick={(e) => {
                  setInitialSlide(2);
                  handleToggle(e);
                }}
                src="Images/BrandInfo1/3.jpg"
                width="100% "
              ></img>
            </div>
            <div key={4}>
              <img
                onClick={(e) => {
                  setInitialSlide(3);
                  handleToggle(e);
                }}
                src="Images/BrandInfo1/4.jpg"
                width="100% "
              ></img>
            </div>
            <div key={5}>
              <img
                onClick={(e) => {
                  setInitialSlide(4);
                  handleToggle(e);
                }}
                src="Images/BrandInfo1/7.jpg"
                width="100% "
              ></img>
            </div>
            <div key={6}>
              <img
                onClick={(e) => {
                  setInitialSlide(5);
                  handleToggle(e);
                }}
                src="Images/BrandInfo1/8.jpg"
                width="100% "
              ></img>
            </div>
            <div key={7}>
              <img
                onClick={(e) => {
                  setInitialSlide(6);
                  handleToggle(e);
                }}
                src="Images/BrandInfo1/6.jpg"
                width="100% "
              ></img>
            </div>
            <div key={8}>
              <img
                onClick={(e) => {
                  setInitialSlide(7);
                  handleToggle(e);
                }}
                src="Images/BrandInfo1/9.jpg"
                width="100% "
              ></img>
            </div>
            <div key={9}>
              <img
                onClick={(e) => {
                  setInitialSlide(8);
                  handleToggle(e);
                }}
                src="Images/BrandInfo1/10.jpg"
                width="100% "
              ></img>
            </div>
            <div key={10}>
              <img
                onClick={(e) => {
                  setInitialSlide(9);
                  handleToggle(e);
                }}
                src="Images/BrandInfo1/11.jpg"
                width="100% "
              ></img>
            </div>
            <div key={11}>
              <img
                onClick={(e) => {
                  setInitialSlide(10);
                  handleToggle(e);
                }}
                src="Images/BrandInfo1/12.jpg"
                width="100% "
              ></img>
            </div>
            <div key={12}>
              <img
                onClick={(e) => {
                  setInitialSlide(11);
                  handleToggle(e);
                }}
                src="Images/BrandInfo1/13.jpg"
                width="100% "
              ></img>
            </div>
          </Slider>
        </>
      ) : (
        <div className="Brandinfo">
          <Logo />
          <Backbutton />
          <h1 id="Brandinfo2_upper_text">
            RECTO <br></br>MEN & WOMEN
          </h1>
          <h1 id="bottom_text" onClick={() => history.push("/brandinfo2")}>
            RECTO <br></br>MEN & WOMEN
          </h1>
          <div>
            <div className="photos" data-relative-input="true" id="pic_1">
              <img
                onClick={(e) => {
                  setInitialSlide(0);
                  handleToggle(e);
                }}
                data-depth="0.2"
                src="Images/BrandInfo1/1.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_2" className="photos" data-relative-input="true">
              <video
                data-depth="0.1"
                autoPlay
                muted
                onClick={(e) => {
                  setInitialSlide(1);
                  handleToggle(e);
                }}
              >
                <source
                  type="video/mp4"
                  src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                />
              </video>
              {/* <img
          data-depth="0.1"
          src="Images/BrandInfo1/2.jpg"
          width="100% "
        ></img> */}
            </div>
            <div id="pic_3" className="photos" data-relative-input="true">
              <img
                onClick={(e) => {
                  setInitialSlide(2);
                  handleToggle(e);
                }}
                s
                data-depth="0.3"
                src="Images/BrandInfo1/3.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_4" className="photos" data-relative-input="true">
              <img
                onClick={(e) => {
                  setInitialSlide(3);
                  handleToggle(e);
                }}
                data-depth="0.6"
                src="Images/BrandInfo1/4.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_7" className="photos" data-relative-input="true">
              <img
                onClick={(e) => {
                  setInitialSlide(4);
                  handleToggle(e);
                }}
                data-depth="0.1"
                src="Images/BrandInfo1/7.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_8" className="photos" data-relative-input="true">
              <img
                onClick={(e) => {
                  setInitialSlide(5);
                  handleToggle(e);
                }}
                data-depth="0.2"
                src="Images/BrandInfo1/8.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_6" className="photos" data-relative-input="true">
              <img
                onClick={(e) => {
                  setInitialSlide(6);
                  handleToggle(e);
                }}
                data-depth="0.0"
                src="Images/BrandInfo1/6.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_9" className="photos" data-relative-input="true">
              <img
                onClick={(e) => {
                  setInitialSlide(7);
                  handleToggle(e);
                }}
                data-depth="0.3"
                src="Images/BrandInfo1/9.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_10" className="photos" data-relative-input="true">
              <img
                onClick={(e) => {
                  setInitialSlide(8);
                  handleToggle(e);
                }}
                data-depth="0.6"
                src="Images/BrandInfo1/10.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_11" className="photos" data-relative-input="true">
              <img
                onClick={(e) => {
                  setInitialSlide(9);
                  handleToggle(e);
                }}
                data-depth="0.2"
                src="Images/BrandInfo1/11.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_12" className="photos" data-relative-input="true">
              <img
                onClick={(e) => {
                  setInitialSlide(10);
                  handleToggle(e);
                }}
                data-depth="0.3"
                src="Images/BrandInfo1/12.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_13" className="photos" data-relative-input="true">
              <img
                onClick={(e) => {
                  setInitialSlide(11);
                  handleToggle(e);
                }}
                data-depth="0.1"
                src="Images/BrandInfo1/13.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_14" className="photos" data-relative-input="true">
              <img
                data-depth="0.2"
                onClick={() => history.push("/brandinfo2")}
                src="Images/BrandInfo1/14.jpg"
                width="100% "
              ></img>
            </div>
            <div id="pic_15" className="photos" data-relative-input="true">
              <img
                data-depth="0.2"
                onClick={() => history.push("/brandinfo2")}
                src="Images/BrandInfo1/15.jpg"
                width="100% "
              ></img>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Brandinfo1;
